<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="emRepairOrders"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button
            v-if="editAuth"
            type="primary"
            @click="$refs.editEMRepairOrder.open(0)">
          新建
        </el-button>
        <el-button
            type="primary"
            :loading="exportLoading"
            @click="exportExcel()">
          维修工单导出
        </el-button>
        <el-button
            type="primary"
            :loading="exportDetailLoading"
            @click="exportDetailExcel()">
          维修工单详情导出
        </el-button>
        <!-- <el-button
            type="primary"
            :loading="exportDetailLoading1"
            @click="exportMTTFExcel()">
          统计
        </el-button>
        <el-button
            type="primary"
            @click="$refs.exportWHL.open(0)">
          统计完好率
        </el-button> -->
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="报修人">
            <el-input v-model.trim="filter.creatorName" clearable/>
          </vm-search>
          <vm-search label="负责人">
            <el-select v-model.trim="filter.mainRepairMan" clearable placeholder="请选择">
              <el-option
                  v-for="item in constants.repairMan.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="设备编号">
            <el-input v-model.trim="filter.equipmentCode" clearable/>
          </vm-search>
          <vm-search label="设备区域">
            <el-input v-model.trim="filter.location" clearable/>
          </vm-search>
          <vm-search label="工单编号">
            <el-input v-model.trim="filter.no" clearable/>
          </vm-search>
          <vm-search label="设备名称">
            <el-input v-model.trim="filter.equipmentName" clearable/>
          </vm-search>
          <vm-search label="紧急程度">
            <el-select v-model.trim="filter.urgency" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.urgencyType)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="修理方式">
            <el-select v-model.trim="filter.repairType" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.faultDealMethod)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="修理结果">
            <el-select v-model.trim="filter.result" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.result)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="状态">
            <el-select v-model.trim="filter.status" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.searchReportOrderStatus)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </vm-search>
          <vm-search label="创建日期">
            <div class="block">
              <el-date-picker
                  v-model="filter.beginCreateTime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="date"
                  style="width: 190px"
                  placeholder="选择开始日期"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.endCreateTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width: 190px"
                  placeholder="选择结束日期"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="no" align="center" width="100px" label="编号">
        <template slot-scope="scope">
          <span
              style="color: #2d8cf0;cursor: pointer;"
              @click="$refs.preview.open(scope.row.pkid)">
            {{scope.row.no}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="equipmentName" align="center" label="设备名称"/>
      <el-table-column prop="faultTime" align="center" label="故障时间" width="140px"/>
      <el-table-column prop="urgency" align="center" width="80px" label="紧急程度">
        <template slot-scope="scope">
          <span>{{constant.urgencyType[scope.row.urgency]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="repairType" align="center" width="80px" label="修理方式">
        <template slot-scope="scope">
          <span>{{constant.faultDealMethod[scope.row.repairType]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="result" align="center" width="80px" label="修理结果">
        <template slot-scope="scope">
          <span>{{constant.result[scope.row.result]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" align="center" width="100px" label="状态">
        <template slot-scope="scope">
          <span>{{constant.reportOrderStatus[scope.row.status]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="repealStatus" align="center" width="100px" label="撤销结果">
        <template slot-scope="scope">
          <span>{{constant.repealStatus[scope.row.repealStatus]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="isHalt" align="center" width="160px" label="是否停机">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.isHalt"
              :disabled="!dealAuth"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="不停机"
              :active-value="1"
              inactive-text="停机"
              :inactive-value="0"
              @change="getIsHalt(scope.row)"/>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status===10 && editAuth" type="info" @click="$refs.editEMRepairOrder.open(scope.row.pkid,'edit')">编辑工单</el-button>
          <el-button v-if="scope.row.status===20 && dealAuth" type="warning" @click="$refs.editEMRepairOrder.open(scope.row.pkid,'deal')">处理工单</el-button>
          <el-button v-if="scope.row.status===25 && dealAuth" type="warning" plain @click="$refs.outEMRepairOrder.open(scope.row.pkid)">转外修</el-button>
          <el-button v-if="scope.row.status===30 && editAuth" type="primary" @click="$refs.editEMRepairOrder.open(scope.row.pkid,'confirm')">确认工单</el-button>
          <el-button v-if="scope.row.repealStatus!==10 && editAuth" @click="repeal(scope.row)">撤销</el-button>
          <el-button v-if="scope.row.repealStatus===10 && dealAuth" @click="$refs.checkRepeal.open(scope.row.pkid)">撤销申请</el-button>
          <el-button v-if="scope.row.status===10 && editAuth" @click="changeStatus(scope.row)">提交</el-button>
          <el-button v-if="scope.row.status===20 && dealAuth" @click="changeStatus(scope.row)">提交</el-button>
          <el-button v-if="scope.row.status===25 && dealAuth" @click="changeStatus(scope.row)">提交</el-button>
          <el-button v-if="scope.row.status===30 && editAuth" @click="changeStatus(scope.row)">提交</el-button>
          <!--          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </vm-table>
    <export-w-h-l-edit ref="exportWHL"/>
    <checkrepeal ref="checkRepeal" @save-success="getList(1)"/>
    <e-m-preview ref="preview" @save-success="getList(1)"/>
    <e-m-repair-order-edit ref="editEMRepairOrder" @save-success="getList(1)"/>
    <e-m-repair-order-out ref="outEMRepairOrder" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import EMRepairOrderEdit from "@/views/em/EMRepairOrder/EMRepairOrderEdit";
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import EMPreview from "@/views/em/EMRepairOrder/EMPreview";
  import EMRepairOrderOut from "@/views/em/EMRepairOrder/EMRepairOrderOut";
  import Checkrepeal from "@/views/em/EMRepairOrder/CheckRepeal";
  import ExportWHLEdit from "@/views/em/EMRepairOrder/exportWHLEdit";

  export default {
    name: "EMRepairOrderList",
    components: {ExportWHLEdit, Checkrepeal, EMRepairOrderOut, EMPreview, EMRepairOrderEdit, VmTable,VmSearch},
    data() {
      return {
        constant,
        constants,
        dialogVisible:false,
        editAuth: this.$auth(89),
        selectAuth: this.$auth(90),
        dealAuth: this.$auth(91),
        idList: "",
        searchTime: "",
        exportLoading: false,
        exportDetailLoading: false,
        exportDetailLoading1: false,
        isHalts: true,
        filter: {
          creatorName: "",//报修人
          mainRepairMan: "",//修理人
          location: "",//区域
          no: "",
          equipmentCode: "",
          equipmentName: "",
          urgency: "",
          repairType: "",
          result: "",
          status: "",
          beginCreateTime: "",
          endCreateTime: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      getIsHalt(row) {
        this.$confirm("确定是否操作?", "提示", {type: "warning"}).then(() => {
          console.log(row.isHalt);
          this.$http
            .get("basic", `emRepairOrders/updateHalt/${row.pkid}`).then(() => {
              this.$message.success("提交成功");
            });
        }).finally(()=>{
          this.getList(-1);
        });
      },
      changeStatus(row) {
        console.log(row);
        if (row.emRepairOrderDetailVOS!=null && row.emRepairOrderDetailVOS.length>0) {
          this.$http
            .get("basic",`emRepairOrders/status/${row.pkid}`).then(() => {
              this.getList(-1);
              this.$message.success("提交成功");
            });
        }else {
          this.$message.error("请填写处理方法");
        }

      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.pkid);
          }
          console.log(ids);
          this.$http
            .delete("basic","emRepairOrders/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 撤销
      repeal(row) {
        this.$confirm("确定撤销吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .get("basic",`emRepairOrders/repealStatus/${row.pkid}/type/${10}`).then(() => {
              this.getList(-1);
              this.$message.success("提交成功");
            });
        });
      },

      repealCheck(row) {
        console.log(row);
        this.dialogVisible = true;
        // this.$confirm("确定撤销吗?", "提示", {type: "warning"}).then(() => {
        //   this.$http
        //     .get("basic",`emRepairOrders/repealStatus/${row.pkid}/type/${10}`).then(() => {
        //       this.getList(-1);
        //       this.$message.success("提交成功");
        //     });
        // });
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","emRepairOrders",row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      // exportExcel() {
      //   window.open(window.config.basicServerUrl + "emRepairOrders/export");
      // },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic","emRepairOrders/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      exportDetailExcel() {
        this.exportDetailLoading = true;
        this.$http
          .exportFile("basic","emRepairOrders/exportDetail", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportDetailLoading = false;
          })
          .catch(() => {
            this.exportDetailLoading = false;
          });
      },
      exportMTTFExcel() {
        this.exportDetailLoading1 = true;
        this.$http
          .exportFile("basic","emRepairOrders/MTTF", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportDetailLoading1 = false;
          })
          .catch(() => {
            this.exportDetailLoading1 = false;
          });
      },
    },
  };
</script>

<style scoped>

</style>
